import AcademicRatingPage from "./AcademicRatingPage";

export default AcademicRatingPage